<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width organisation-structure-page"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">Organisation Structure</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div class="drag-tree-wrapper">
          <div class="drag-tree-header">
            {{ $store.getters[`user/selecteOrganisationName`] }}
          </div>
          <div class="drag-tree-content">
            <el-tree
              :data="data"
              node-key="id"
              default-expand-all
              draggable
              :expand-on-click-node="false"
              :allow-drop="
                () => {
                  return true
                }
              "
              :allow-drag="
                () => {
                  return true
                }
              "
            >
              <span slot-scope="{ node, data }">
                <el-input size="mini" v-model="data.label"></el-input>
              </span>
            </el-tree>
          </div>
          <div class="drag-tree-footer">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              class="add-item-btn"
              @click="addItem"
              >Add Item</el-button
            >
            <el-button
              type="success"
              plain
              class="common-btn"
              :loading="loading"
              @click="saveOrg"
              >{{ $t('text.save') }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      user: JSON.parse(localStorage.getItem('user')),
      data: [
        {
          id: 1,
          label: 'Building 1',
          children: [
            {
              id: 2,
              label: 'Floor 1',
              children: [
                {
                  id: 3,
                  label: 'Room 1'
                },
                {
                  id: 4,
                  label: 'Room 2'
                }
              ]
            },
            {
              id: 5,
              label: 'Floor 2',
              children: [
                {
                  id: 6,
                  label: 'Room 1'
                },
                {
                  id: 7,
                  label: 'Room 2'
                }
              ]
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  methods: {
    addItem() {
      this.data.push({
        id: Math.random(),
        label: 'New Item'
      })
    },
    saveOrg() {
      // console.log(this.data)
    }
  }
}
</script>
